import React, {useMemo} from 'react';


const CustomComponent = props => {

  const Component = props.dt_cust_comp;
  // const params = {
  //   fromSettings: props.params,
  //   fromTable: props.tableParams,
  // }
  const MemoizedComponent = useMemo(() => Component ? <Component {...props} /> : null, [Component, props])

  return(
    <div>
      {MemoizedComponent}
    </div>
  );

}

export default CustomComponent;
